module.exports = __webpack_public_path__ + "img/98.734314c6.jpg";